module.exports = __webpack_public_path__ + "img/blur_4.2b914f64.jpg";